import { transformWon } from "@repo/utils/src/number";
import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";

import Icon from "@components/atoms/Icon";

import { IconName } from "@const/enum";

interface IProps {
  salePrice: number;
  originalPrice: number;
  className?: string | classNames.ArgumentArray;
}

function CompareAtPrice({ salePrice, originalPrice, className }: IProps) {
  const { t } = useTranslation();
  const isSale = originalPrice > salePrice; // 정가 > 판매가

  return (
    <>
      {isSale ? (
        <div className={classNames("flex gap-1", className)}>
          <span className="relative h-fit">
            <span>
              {transformWon(originalPrice)}
              {t("account.order.currency")}
            </span>
            <span className="center absolute w-full">
              <Icon className="size-full" name={IconName.Line_long} />
            </span>
          </span>
          <span>
            {transformWon(salePrice)}
            {t("account.order.currency")}
          </span>
        </div>
      ) : (
        <div className={classNames(className)}>{transformWon(salePrice)}원</div>
      )}
    </>
  );
}

export default CompareAtPrice;
